import React from 'react';
function AcademicsSection() {  return (
    <section id="academics" style={{ background: "var(--bg-soft)" }}>
      <div className="wrap">
        <div className="section-head reveal">
          <div className="eyebrow">{"Academics"}</div>
          <h2>{"Programs That Inspire and Challenge"}</h2>
          <p>{"A connected curriculum from first classroom to final exam — each stage built to prepare a student for the next."}</p>
        </div>
        <div className="card-row reveal" style={{ marginTop: "44px" }}>
          <div className="prog-card">
            <div className="ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="#3FA9E0" strokeWidth="2">
                <path d="M4 19V5a2 2 0 0 1 2-2h9l5 5v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"></path>
                <path d="M14 3v5h5"></path>
              </svg>
            </div>
            <h3>{"Primary School"}</h3>
            <p>{"Building strong basics through engaging, activity-based learning."}</p>
          
          </div>
          <div className="prog-card">
            <div className="ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="#3FA9E0" strokeWidth="2">
                <path d="M12 20l9-5-9-5-9 5 9 5z"></path>
                <path d="M3 15v4M21 15v4"></path>
              </svg>
            </div>
            <h3>{"Middle School"}</h3>
            <p>{"Encouraging exploration, creativity and conceptual understanding."}</p>
           
          </div>
          <div className="prog-card">
            <div className="ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="#3FA9E0" strokeWidth="2">
                <rect x="3" y="5" width="18" height="12" rx="2"></rect>
                <path d="M8 21h8M12 17v4"></path>
              </svg>
            </div>
            <h3>{"High School"}</h3>
            <p>{"Preparing students for future success with rigorous academics."}</p>
            <a href="#admissions" className="more">{"Read More →"}</a>
          </div>
          <div className="prog-card">
            <div className="ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="#3FA9E0" strokeWidth="2">
                <path d="M9 3h6l1 4H8l1-4z"></path>
                <path d="M8 7v6l-4 8h16l-4-8V7"></path>
              </svg>
            </div>
            <h3>{"Practical Studies"}</h3>
            <p>{"Building useful skills through hands-on projects, experiments and real-world learning."}</p>
         
          </div>
          <div className="prog-card">
            <div className="ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="#3FA9E0" strokeWidth="2">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M3 12h18M12 3c2.5 2.5 4 6 4 9s-1.5 6.5-4 9c-2.5-2.5-4-6-4-9s1.5-6.5 4-9z"></path>
              </svg>
            </div>
            <h3>{"Global Learning"}</h3>
            <p>{"Building global awareness and leadership for tomorrow."}</p>
          
          </div>
        </div>
      </div>
    </section>
  );
}

export default AcademicsSection;
